import React, { useState } from "react";
import { FaPlay, FaCog, FaExternalLinkAlt } from "react-icons/fa";
import useBingoStore from "../store";

const ConfigurarBingo = () => {
  const { configureBingo } = useBingoStore();
  
  const [bingoName, setBingoName] = useState("");
  const [soundOption, setSoundOption] = useState("numbers_phrases");
  const [animationOption, setAnimationOption] = useState("3d");

  const handleStartBingo = () => {
    configureBingo({
      bingoName: bingoName.trim() || "Bingo",
      soundOption,
      animationOption,
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-6">
          <div className="flex items-center gap-3">
            <FaCog className="text-3xl" />
            <h1 className="text-3xl font-bold">Configurar Bingo</h1>
          </div>
          <p className="mt-2 text-blue-100">
            Configure seu bingo antes de começar. Todas as opções podem ser alteradas durante o jogo.
          </p>
        </div>

        {/* Form */}
        <div className="p-6 space-y-6">
          {/* Bingo Name */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-2">
              Nome do Bingo
            </label>
            <input
              type="text"
              value={bingoName}
              onChange={(e) => setBingoName(e.target.value)}
              placeholder="Ex: Bingo de Natal 2025"
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none transition-colors text-lg"
            />
            <p className="mt-1 text-sm text-gray-500">
              Este nome será exibido no cabeçalho da página durante o jogo.
            </p>
          </div>

          {/* Sound Option */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-2">
              Opções de Som
            </label>
            <div className="space-y-2">
              <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="sound"
                  value="none"
                  checked={soundOption === "none"}
                  onChange={(e) => setSoundOption(e.target.value)}
                  className="w-5 h-5 text-blue-600"
                />
                <div>
                  <span className="font-medium">Sem Som</span>
                  <p className="text-sm text-gray-500">Nenhum áudio será reproduzido</p>
                </div>
              </label>
              <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="sound"
                  value="numbers"
                  checked={soundOption === "numbers"}
                  onChange={(e) => setSoundOption(e.target.value)}
                  className="w-5 h-5 text-blue-600"
                />
                <div>
                  <span className="font-medium">Somente Números</span>
                  <p className="text-sm text-gray-500">Apenas o número sorteado será anunciado</p>
                </div>
              </label>
              <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="sound"
                  value="numbers_phrases"
                  checked={soundOption === "numbers_phrases"}
                  onChange={(e) => setSoundOption(e.target.value)}
                  className="w-5 h-5 text-blue-600"
                />
                <div>
                  <span className="font-medium">Números + Frases Engraçadas</span>
                  <p className="text-sm text-gray-500">Número e uma frase divertida serão anunciados</p>
                </div>
              </label>
            </div>
          </div>

          {/* Animation Option */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-2">
              Animação do Sorteio
            </label>
            <div className="space-y-2">
              <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="animation"
                  value="3d"
                  checked={animationOption === "3d"}
                  onChange={(e) => setAnimationOption(e.target.value)}
                  className="w-5 h-5 text-blue-600"
                />
                <div>
                  <span className="font-medium">Globo 3D</span>
                  <p className="text-sm text-gray-500">Animação 3D com globo de bingo giratório</p>
                </div>
              </label>
              <label className="flex items-center gap-3 p-3 border-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <input
                  type="radio"
                  name="animation"
                  value="simple"
                  checked={animationOption === "simple"}
                  onChange={(e) => setAnimationOption(e.target.value)}
                  className="w-5 h-5 text-blue-600"
                />
                <div>
                  <span className="font-medium">Simples</span>
                  <p className="text-sm text-gray-500">Apenas o número com animação de rolagem</p>
                </div>
              </label>
            </div>
          </div>

          {/* Cartelas Link */}
          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-2 border-amber-200 rounded-lg p-4">
            <h3 className="font-semibold text-amber-800 mb-2">📋 Precisa de Cartelas de Bingo?</h3>
            <p className="text-amber-700 text-sm mb-3">
              Acesse o link abaixo para gerar e imprimir cartelas de bingo personalizadas gratuitamente!
            </p>
            <a
              href="https://geradornv.com.br/imprimir-cartelas-bingo/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium transition-colors"
            >
              <FaExternalLinkAlt />
              Gerar Cartelas de Bingo
            </a>
          </div>

          {/* Start Button */}
          <button
            onClick={handleStartBingo}
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-4 px-6 rounded-lg transition-all transform hover:scale-[1.02] shadow-lg flex items-center justify-center gap-3 text-xl"
          >
            <FaPlay />
            Iniciar Bingo
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfigurarBingo;
